var _defs, _clipPath, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonialsIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 70",
    enableBackground: "new 0 0 66 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 16,
    y: 18,
    width: 34,
    height: 34
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092429571458131828400000008239446503709793448_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000092429571458131828400000008239446503709793448_)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDCDC",
    d: "M37.1,39.8l-1.6-0.2l-0.7-1.4c-0.3-0.7-1-1.1-1.8-1.1s-1.5,0.4-1.8,1.1l-0.7,1.4l-1.6,0.2 c-0.7,0.1-1.3,0.7-1.6,1.3c-0.2,0.7,0,1.5,0.5,2l1.1,1.1l-0.3,1.6c-0.1,0.7,0.2,1.5,0.8,1.9c0.7,0.5,1.5,0.5,2.1,0.2l1.4-0.7 l1.4,0.7c0.7,0.4,1.5,0.3,2.1-0.1c0.6-0.4,0.9-1.2,0.8-1.9L37,44.3l1.1-1.1c0.6-0.5,0.8-1.3,0.5-2.1 C38.5,40.4,37.8,39.9,37.1,39.8z M43.9,24.6l-4.5-2l-2-4.5C37.2,18,37.1,18,37,18H23c-0.3,0-0.5,0.1-0.7,0.3 C22.2,18.5,22,18.7,22,19v12c0,0.5,0.5,1,1,1h3.4l1.7,3.4c0.2,0.4,0.5,0.6,0.9,0.6H43c0.5,0,1-0.5,1-1V25 C44,24.8,43.9,24.7,43.9,24.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141456067804800401440000013724231386331561616_",
    gradientUnits: "userSpaceOnUse",
    x1: 33,
    y1: 20,
    x2: 33,
    y2: 53.9204,
    gradientTransform: "matrix(1 0 0 -1 0 72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6060"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9A9A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000141456067804800401440000013724231386331561616_)",
    d: "M46.9,34H29.6l-1.7-3.4C27.7,30.2,27.4,30,27,30 h-8c-0.6,0-1,0.4-1,1v18c0,1.7,1.3,3,3,3H45c1.7,0,3-1.3,3-3V35C47.9,34.4,47.5,34,46.9,34z M37.5,42.5L36,43.9l0.4,2.1 c0.1,0.4-0.1,0.7-0.4,1c-0.3,0.2-0.7,0.3-1,0.1l-1.9-1l-1.9,1c-0.3,0.2-0.7,0.1-1-0.1c-0.3-0.2-0.5-0.6-0.4-1l0.4-2.1l-1.5-1.5 c-0.3-0.3-0.4-0.7-0.3-1c0.1-0.4,0.4-0.6,0.8-0.7l2.1-0.3l0.9-1.9c0.3-0.7,1.5-0.7,1.8,0l0.9,1.9l2.1,0.3c0.4,0.1,0.7,0.3,0.8,0.7 C37.9,41.8,37.8,42.2,37.5,42.5z M38.4,24.6h5.5c0-0.1-0.1-0.2-0.2-0.3l-6-6c-0.1-0.1-0.2-0.2-0.3-0.2v5.5 C37.4,24.1,37.8,24.6,38.4,24.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsIcon1);
export default __webpack_public_path__ + "static/media/testimonials-icon-1.1e550ac33840647fa508b5937df94199.svg";
export { ForwardRef as ReactComponent };